'use strict';

var GridCollapsePanelButtonDirective = function GridCollapsePanelButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-collapse-panel-button.html'),
    controller: 'GridCollapsePanelButtonController'
  };
};
GridCollapsePanelButtonDirective.$inject = [];
module.exports = GridCollapsePanelButtonDirective;